import { useQuery } from 'react-query';
import { userProfileService } from 'services/auth';

import GuestUser from 'components/pages/profile/GuestUser';
import LoggedInUser from 'components/pages/profile/LoggedInUser';
import Spinner from '@core/components/spinner/Spinner';

import { isUserLoggedIn, getAccessToken } from 'utils/authentication';

import { NextSeo } from 'next-seo';
import { generateSeoProps } from 'router/seoprops/generateSeoProps';

import classes from './index.module.scss';

const Profile = () => {
	const { data, isLoading, refetch } = useQuery(
		['user-profile', isUserLoggedIn(), getAccessToken()],
		userProfileService,
		{
			cacheTime: 20 * 60 * 1000,
			staleTime: 20 * 60 * 1000
		}
	);
	const seoProps = generateSeoProps({
		title: 'Pharmuni | Profile',
		canonical: 'profile'
	});
	return (
		<>
			<NextSeo {...seoProps} />
			{data && !isLoading ? (
				<div className="container">
					{data.data.logged_in ? (
						<LoggedInUser refetchHandler={refetch} data={data.data} />
					) : (
						<GuestUser data={data.data} />
					)}
				</div>
			) : (
				<div className={classes['loading']}>
					<Spinner />
				</div>
			)}
		</>
	);
};

export default Profile;
